import { SearchResults } from "../../Shared/scriptts/interfaces";
import { toggleElement } from "../../Shared/scriptts/rootcomponents/toggle";
import { params, executeSearchUrl, displayResults } from '../search-main';

declare var gIsSearchFiltersEnabled: boolean;

export const minimumRadius = "0";
export const defaultRadius = "25";
const countIcon = document.createElement('span');
const radiusOptions = ['5', '10', '25', '50', '100'];

/**
 * Set the location filter display (Distance/radius filter for SearchFilters feature toggle)
 * @param data The data returned from the search API
 */
export function displayLocationFilter(data: SearchResults) {
    if (gIsSearchFiltersEnabled) {
        displayLocationFilterTemp(data);
    }

    const relocationInput = document.querySelector<HTMLInputElement>('#relocation_assistance');
    const teleworkInput = document.querySelector<HTMLInputElement>('#telework_eligible');

    if (!relocationInput || !teleworkInput) {
        return;
    }

    const titleElem = document.querySelector<HTMLElement>('#titleaccordion-location');
    if (titleElem !== null) {
        countIcon.className = 'bg-warning rounded-full py-1 px-2 ml-2';
        if (!titleElem.contains(countIcon)) {
            titleElem.appendChild(countIcon);
        }
    }

    setFilterCounts(data);
    setRadiusDisplay(data.IsRadialSearch);
    setCountIconDisplay();

    relocationInput.addEventListener('change', filterItemChanged);
    teleworkInput.addEventListener('change', filterItemChanged);

    relocationInput.checked = (params.RelocationIndicator?.toString() === 'true') ? true : false;
    teleworkInput.checked = (params.TeleworkIndicator?.toString() === 'true') ? true : false;
}

// TODO: This becomes the new displayLocationFilter when we no longer need the SearchFilters feature toggle.
function displayLocationFilterTemp(data: SearchResults) {
    if (data.IsRadialSearch) {
        const filterButton = document.querySelector<HTMLElement>('#filter-button-location');
        const filterButtonText = document.querySelector<HTMLElement>('#filter-button-text-location');

        setRadiusParam();

        filterButton?.classList.add('button-search-filter-applied');
        filterButton?.classList.remove('button-search-filter');
        filterButton?.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.add('fill-white');
            icon.classList.remove('fill-gray-darkest');
        });

        if (filterButtonText) {
            filterButtonText.textContent = `${params.Radius} mi`;
        }

        document.querySelector<HTMLElement>('#filter-location-container')?.classList.remove('hidden');
        document.querySelectorAll<HTMLInputElement>('[name="radius"]').forEach(elem => {
            elem.checked = (params.Radius === elem.value) ? true : false;
            elem.addEventListener('change', () => radiusOptionChanged(elem));
        });
        document.querySelector<HTMLButtonElement>('#reset-filters-location')?.addEventListener('click', resetButtonClicked);
    }
    else {
        params.Radius = undefined;
        document.querySelector<HTMLElement>('#filter-location-container')?.classList.add('hidden');
        return;
    }
}

function setRadiusParam() {
    params.Radius = params.Radius ?? defaultRadius;

    if (radiusOptions.includes(params.Radius)) {
        return;
    }

    const currentRadius = parseInt(params.Radius, 10);
    const numericOptions = radiusOptions.map(opt => parseInt(opt, 10));

    if (currentRadius <= numericOptions[0]) {
        params.Radius = radiusOptions[0];
    }
    else if (currentRadius >= numericOptions[numericOptions.length - 1]) {
        params.Radius = radiusOptions[numericOptions.length - 1];
    }
    else {
        const mappedRadius = numericOptions.reduce((prev, curr) => {
            return (Math.abs(curr - currentRadius) < Math.abs(prev - currentRadius) ? curr : prev);
        }).toString();

        params.Radius = mappedRadius;
    }
}

function radiusOptionChanged(elem: HTMLInputElement) {
    const filterButton = document.querySelector<HTMLElement>('#filter-button-location');
    const filterButtonText = document.querySelector<HTMLElement>('#filter-button-text-location');

    params.Radius = elem.value;
    displayResults(executeSearchUrl, false, true);

    if (!filterButton || !filterButtonText) {
        return;
    }

    toggleElement(filterButton, false);
    filterButtonText.textContent = `${params.Radius} mi`;
}

function resetButtonClicked() {
    params.Radius = defaultRadius;
    document.querySelectorAll<HTMLInputElement>('[name="radius"]').forEach(elem => elem.checked = elem.value === defaultRadius);
    displayResults(executeSearchUrl, false, true);
}

function setRadiusDisplay(isRadialSearch: boolean) {
    const radiusSlider = document.querySelector<HTMLInputElement>('#location-radius-slider');
    const radiusMin = document.querySelector<HTMLInputElement>('#location-radius-min');

    if (!radiusSlider || !radiusMin) {
        return;
    }

    radiusSlider.addEventListener('change', radiusMinChanged);
    radiusMin.addEventListener('change', radiusMinChanged);

    radiusMin.value = params.Radius ?? defaultRadius;
    radiusSlider.value = radiusMin.value;
    radiusSlider.setAttribute('min', minimumRadius);

    if (isRadialSearch === true) {
        document.querySelector<HTMLElement>('#radius-filter')?.classList.remove('hidden');
        params.Radius = radiusMin.value;
    }
    else {
        document.querySelector<HTMLElement>('#radius-filter')?.classList.add('hidden');
        params.Radius = undefined;
    }
}

function radiusMinChanged(evt: Event) {
    const elem = <HTMLInputElement>(evt.target);
    const slider = document.querySelector<HTMLInputElement>('#location-radius-slider');
    const textInput = document.querySelector<HTMLInputElement>('#location-radius-min');

    if (!slider || !textInput) {
        return;
    }

    let radius = parseInt(textInput.value);
    if (isNaN(radius)) {
        textInput.value = defaultRadius;
    }
    else if (radius < parseInt(minimumRadius)) {
        textInput.value = minimumRadius;
    }

    if (elem.id === slider.id) {
        textInput.value = slider.value;
    }
    else {
        slider.value = textInput.value;
    }

    params.Radius = textInput.value;
    displayResults(executeSearchUrl);
    setCountIconDisplay();
}

function filterItemChanged(evt: Event) {
    if (document.querySelector<HTMLInputElement>('#relocation_assistance')?.checked) {
        params.RelocationIndicator = true;
    }
    else {
        params.RelocationIndicator = undefined;
    }

    if (document.querySelector<HTMLInputElement>('#telework_eligible')?.checked) {
        params.TeleworkIndicator = true;
    }
    else {
        params.TeleworkIndicator = undefined;
    }

    params.Page = '1';
    displayResults(executeSearchUrl, false, true);
    setCountIconDisplay();
}

function setCountIconDisplay() {
    let count = 0;
    if (params.Radius !== undefined && params.Radius !== null) {
        ++count;
    }
    if (params.RelocationIndicator !== undefined && params.RelocationIndicator !== null && params.RelocationIndicator.toString() === 'true') {
        ++count;
    }
    if (params.TeleworkIndicator !== undefined && params.TeleworkIndicator !== null && params.TeleworkIndicator.toString() === 'true') {
        ++count;
    }
    if (count > 0) {
        countIcon.innerText = count.toString();
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }
}

function setFilterCounts(data: SearchResults) {
    const relocationCount = document.querySelector<HTMLElement>('#item-count-relocation');
    const teleworkCount = document.querySelector<HTMLElement>('#item-count-telework');

    if (!relocationCount || !teleworkCount) {
        return;
    }
    relocationCount.innerText = `(${data.f.ri?.relocation ?? 0})`;
    teleworkCount.innerText = `(${data.f.ti?.telework ?? 0})`;
}
